import {
    DEFAULT_SCHEME_NAME,
    SCHEME_CHANGE_EVENT,
    SCHEME_STORAGE_KEY,
} from "../constants";
import { usePersistedSetting } from "./usePersistedSetting";

/**
 * Manages the user's preferred code highlight scheme name.
 *
 * The selected scheme name is persisted in localStorage and kept in sync
 * across all mounted consumers via the {@link SCHEME_CHANGE_EVENT} window
 * event.
 *
 * @returns A stateful tuple of `[schemeName, setSchemeName]` where
 *   `schemeName` defaults to `{@link DEFAULT_SCHEME_NAME}` when nothing has
 *   been stored.
 */
export function useCodeSchemeName(): [string, (name: string) => void] {
    return usePersistedSetting(
        SCHEME_STORAGE_KEY,
        DEFAULT_SCHEME_NAME,
        SCHEME_CHANGE_EVENT
    );
}
